import React from "react";
import Logo from "/assets/images/swayamRiskLogoBlue.png";
import style from "./PersonalityAnalysis.module.css";
import Bg from "/assets/PdfNew/pgbg6.png";


const PersonalityAnalysis = () => {
    return (
        <div className={style.PersonalityAnalysisBg}>
            {/* Background */}
            <img src={Bg} alt="background" className={style.PersonalityAnalysisBg} />

            {/* Logo */}
            <img src={Logo} alt="logo" className={style.logo} />


            {/* Content */}
            <div className={style.content}>
                <p className={style.title}>
                    <strong>Personality Analysis</strong>
                </p>
                <br></br>


                <p   >
                    Curious minds like yours turn questions into discoveries and possibilities into progress. Here’s your personality decoded in the simplest format. Explore how you think, feel, and work, clearly and confidently.
                    <br></br>
This section is about you — how you think, how you feel, and how you naturally approach the world around you. Your personality results and aptitude scores are laid out here in simple, clear language. Together they tell a story — one that connects who you are today with the careers where you are most likely to grow, succeed and feel genuinely happy.
</p>
            </div>

        </div>
    );
};

export default PersonalityAnalysis;
